export default "__VITE_ASSET__CRGGbXuJ__"